import * as React from 'react';
import { Link } from "react-router-dom";
import { IconPlus } from "@tabler/icons-react";
import { Button } from "@mantine/core";

interface CreateButtonProps {
    route: string;
}

const CreateButton = ({
    route
}: CreateButtonProps) => {
    return (
        <Button
            component={Link}
            to={`${route}/new`}
            leftIcon={<IconPlus size={18}/>}
            color={'color-secondary'}
        >
            Үүсгэх
        </Button>
    )
};

export default CreateButton;